import NewGrowMap from './NewGrowMap';

export default NewGrowMap;